import React from "react";
import { Helmet } from "react-helmet";
import { Platform } from "react-native";
import { usePathname } from "expo-router";

interface SeoProps {
	title?: string | null;
	description?: string | null;
	keywords?: string | null;
}

const Seo = (props: SeoProps) => {
	const { title, description, keywords } = props;
	const pathname = usePathname();

	if (Platform.OS !== "web") return null;

	// Use Expo Router pathname to construct canonical URL
	const baseUrl = typeof window !== "undefined" ? window.location.origin : process.env.EXPO_PUBLIC_ABCO_URL;
	const canonicalUrl = `${baseUrl}${pathname}`;

	return (
		<Helmet>
			<meta charSet="utf-8" />
			{title && <title>{title}</title>}
			{description && <meta name="description" content={description} />}
			{keywords && <meta name="keywords" content={keywords} />}
			{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
		</Helmet>
	);
};

export default Seo;
